import { CURIOSO_POWER, GLYPH_POWER, SKILL_CATEGORY } from './constants';

export default {
  reading: {
    backpackPowersText: {
      powers: {
        [CURIOSO_POWER.DEFAULT]: {
          title: CURIOSO_POWER.DEFAULT,
          description: 'Curioso will gain powers as you gain reading skills.',
        },
        [CURIOSO_POWER.BOOK_MAGIC]: {
          title: CURIOSO_POWER.BOOK_MAGIC,
          description: 'The power to pull items and ideas out of books.',
        },
        [CURIOSO_POWER.INSPIRATION]: {
          title: CURIOSO_POWER.INSPIRATION,
          description: 'The power to detect and collect items that inspire.',
        },
        [CURIOSO_POWER.MIND_READER]: {
          title: CURIOSO_POWER.MIND_READER,
          description: 'The power to reveal character motivations.',
        },
        [GLYPH_POWER.SHADE_SHIFTER]: {
          title: GLYPH_POWER.SHADE_SHIFTER,
          description: 'The power to shift the shades of meaning of a word.',
        },
        [GLYPH_POWER.PORTALING]: {
          title: GLYPH_POWER.PORTALING,
          description: 'The power to jump into texts for deeper understanding.',
        },
        [GLYPH_POWER.MIND_MAPPING]: {
          title: GLYPH_POWER.MIND_MAPPING,
          description: 'The power to connect ideas together to solve problems.',
        },
      },
      skills: {
        [SKILL_CATEGORY.SOUNDS]: {
          title: 'Sounds',
          description: 'Exploring letter sounds and shapes.',
        },
        [SKILL_CATEGORY.LETTERS]: {
          title: 'Letters',
          description: 'Decoding and blending letters into words.',
        },
        [SKILL_CATEGORY.IMAGES]: {
          title: 'Images',
          description: 'Making pictures in your mind when you read.',
        },
        [SKILL_CATEGORY.IDEAS]: {
          title: 'Ideas',
          description: 'Reading to uncover knowledge and ideas.',
        },
        [SKILL_CATEGORY.WORDS]: {
          title: 'Words',
          description: 'Discovering new words and their meanings.',
        },
      },
    },
  },
  lectura: {
    backpackPowersText: {
      powers: {
        [CURIOSO_POWER.DEFAULT]: {
          title: 'Poderes curiosos',
          description: 'El curioso conseguirá poderes a medida que consigas habilidades de lectura.',
        },
        [CURIOSO_POWER.BOOK_MAGIC]: {
          title: 'Magia de Libro',
          description: 'El poder de sacar elementos e ideas de los libros.',
        },
        [CURIOSO_POWER.INSPIRATION]: {
          title: 'Inspiración',
          description: 'El poder de detectar y encontrar elementos que inspiran.',
        },
        [CURIOSO_POWER.MIND_READER]: {
          title: 'Revelación',
          description: 'El poder de revelar las motivaciones del personaje.',
        },
        [GLYPH_POWER.SHADE_SHIFTER]: {
          title: 'Significado',
          description: 'El poder de intercambiar los diferentes significados de una palabra.',
        },
        [GLYPH_POWER.PORTALING]: {
          title: 'Inmersión',
          description: 'El poder de sumergirse en los textos para una comprensión más profunda.',
        },
        [GLYPH_POWER.MIND_MAPPING]: {
          title: 'Mapa Mental',
          description: 'El poder de conectar ideas para resolver problemas.',
        },
      },
      skills: {
        [SKILL_CATEGORY.SOUNDS]: {
          title: 'Sonidos',
          description: 'Explorar los sonidos y las formas de las letras.',
        },
        [SKILL_CATEGORY.LETTERS]: {
          title: 'Letras',
          description: 'Decodificar y combinar letras para formar palabras.',
        },
        [SKILL_CATEGORY.IMAGES]: {
          title: 'Imágenes',
          description: 'Crear imágenes en tu mente mientras lees.',
        },
        [SKILL_CATEGORY.IDEAS]: {
          title: 'Ideas',
          description: 'Leer para descubrir conocimientos e ideas.',
        },
        [SKILL_CATEGORY.WORDS]: {
          title: 'Palabras',
          description: 'Descubrir nuevas palabras y sus significados.',
        },
      },
    },
  },
};
